<template lang="pug">
form(v-on:submit.prevent)
  .modal-card(style="width: auto")
    .modal-card-head
      .modal-card-title {{verbGerund}} {{noun}}
    .modal-card-body
      .field
        .label Location
        .control
          input.input(placeholder="Location" ref="focus" v-bind:class="[$v.location.$error || $v.place.$error ? 'is-danger' : 'is-success']" v-bind:value="$v.location.$model" v-on:input="onInput($event)" v-on:keypress.13.prevent)
        .help(class="is-danger" v-show="$v.location.$error && !$v.location.required") Location is required
        .help(class="is-danger" v-show="!$v.location.$error && $v.place.$error && !$v.place.required") Location is invalid
      .field(v-if="showName")
        .label Name
        .control
          input.input(placeholder="Name" v-bind:class="[$v.name.$error ? 'is-danger' : 'is-success']" v-model="$v.name.$model")
        .help(class="is-danger" v-show="$v.name.$error && !$v.name.required") Name is required
      .field(v-if="showRange")
        .label Range
        .control
          input.input(min="0" placeholder="Range" type="number" v-bind:class="[$v.range.$error ? 'is-danger' : 'is-success']" v-model.number="$v.range.$model")
        .help(class="is-danger" v-show="!$v.range.$error && $v.range.minRange") Range is invalid
        .help(class="is-danger" v-show="$v.range.$error && !$v.range.required") Range is required
      .field(v-if="showSave")
        .control
          label.checkbox
            input(type="checkbox" v-model="$v.save.$model")
            | &nbsp;
            span Save
    .modal-card-foot
      button(class="button has-text-weight-semibold" v-on:click="$parent.close()") Close
      button(class="button has-text-weight-semibold is-primary" v-bind:disabled="$v.$invalid" v-on:click="$parent.close(); impl(name, place, range, save)") {{verbBase}} {{noun}}
</template>

<script>
import { minValue, required } from 'vuelidate/lib/validators'

import ApiMixin from '@/mixins/ApiMixin.vue'

export default {
  mixins: [
    ApiMixin
  ],
  props: {
    impl: {
      required: true,
      type: Function
    },
    initialLocation: {
      required: true,
      type: String
    },
    noun: {
      required: true,
      type: String
    },
    showName: {
      default: false,
      required: false,
      type: Boolean
    },
    showRange: {
      default: false,
      required: false,
      type: Boolean
    },
    showSave: {
      default: true,
      required: false,
      type: Boolean
    },
    verbBase: {
      required: true,
      type: String
    },
    verbGerund: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      location: this.initialLocation,
      name: null,
      place: null,
      range: null,
      save: false
    }
  },
  mounted () {
    this.$refs.focus.focus()
    const options = {
      componentRestrictions: {
        country: ['GG', 'JE', 'UK']
      }
    }
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.focus, options) // eslint-disable-line no-undef
    this.autocomplete.addListener('place_changed', this.onPlaceChanged)
  },
  methods: {
    onInput (event) {
      this.setPlace(null)
      this.setLocation(event.target.value)
    },
    onPlaceChanged () {
      this.setPlace(this.autocomplete.getPlace())
      this.setLocation(this.place.formatted_address)
    },
    setLocation (location) {
      this.location = location
      this.$v.location.$touch()
    },
    setPlace (place) {
      this.place = place
      this.$v.place.$touch()
    }
  },
  validations () {
    const nameValidations = {
      name: {
        required
      }
    }
    const rangeValidations = {
      range: {
        minValue: minValue(0),
        required
      }
    }
    let validations = {
      location: {
        required
      },
      place: {
        required
      },
      save: {}
    }
    if (this.showName) {
      validations = { ...validations, ...nameValidations }
    }
    if (this.showRange) {
      validations = { ...validations, ...rangeValidations }
    }
    return validations
  }
}
</script>
